<template>
	<div class="col-12 col-lg-4">
		<b-form-group id="example-input-group-3">
			<label for="example-input-group-3" class="d-block col-form-label-sm">{{ field.name }}</label>

			<b-form-select
				id="example-input-33"
				name="example-input-33"
				aria-describedby="input-3-live-feedback"
				:state="isValidate"
				:options="field.options"
				:value="value"
				@input="$emit('input', $event)"
				@change="[$emit('change', $event), $emit('blur', value)]"
				@focus="$emit('focus', $event)"
				@blur="$emit('blur', value)"
			/>

			<b-form-invalid-feedback id="input-33-live-feedback">
				{{ $t('required') }}
			</b-form-invalid-feedback>
		</b-form-group>
	</div>
</template>

<script>
/**
 * в @change дополнительно триггерится blur, т.к. похоже у изначального компонента события blur нет.
 * Blur необходим, т.к. при срабатывании этого события проходит валидация.
 */
export default {
	name: 'Dropdown',
	props: {
		field: {
			type: Object,
			default: () => {
			},
		},
		value: { default: null },
	},
	data() {
		return {
			isValidate: null,
		};
	},
	methods: {
		checkValidation(form) {
			if (this.value) {
				this.isValidate = typeof form[this.field.slug]?.$error !== 'undefined' ? !form[this.field.slug]?.$error : true;
			} else {
				this.isValidate = false;
			}
			return this.isValidate;
		},
	},
};
</script>

<style scoped>

</style>
